import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ISecurityRoleInfo } from "../models/auto-generated";

@Injectable({
  providedIn: "root"
})
export class SecurityRolesService {
  private getBaseRoute(instanceId: string): string {
    return `/api/configurations/${instanceId}/security-roles`;
  }
  constructor(private http: HttpClient) {}

  get(instanceId: string): Observable<ISecurityRoleInfo[]> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.get<ISecurityRoleInfo[]>(baseRoute);
  }
}
